<div class="row no-gutters mobile-width">
  <!-- navigation -->
  <aside class="col-12 col-md-3 navigation-background">
    <div class="navigation-wrapper">
    <ng-container *ngFor="let item of menuData; index as i">
      <div class="nav-block" *ngIf="item.visible" [attr.data-index]="i" [class.active]="sectionBlock === item.name">
        <a [routerLink]="" (click)="submitBlock(disclosuresForm, item.path)">
          <div class="active-block"></div>
          <div class="validation-indicator" [ngClass]="{'valid': item.valid, 'uhoh': item.valid === false}">
            <span class="icon" *ngIf="item.valid != null && item.valid === false">!</span>
            <i class="fas fa-check" *ngIf="item.valid != null && item.valid"></i>
          </div>
          <div [innerHtml]="item.label || 'Confirmation'" class="block-name"></div>
        </a>
      </div>
    </ng-container>
  </div>
</aside>
<!-- /navigation -->

<!-- main container -->
<main class="col col-12 col-md-9 col-main" [@fadeAnimation]="true">
  <h1 class="section-title" [innerHtml]="sectionData.blockHeading"></h1>
  <p class="lead disclosure-send-email-notification" *ngIf="disableForward">Please send the application to <strong>{{proposedInsuredName.FirstName}} {{proposedInsuredName.LastName}}</strong> for their signature before continuing.</p>
  <form [formGroup]="disclosuresForm">
    <div id="disclosuresPn" class="disclosures-wrapper">
      <!-- Question loop -->
      <ng-container *ngFor="let question of questions">
        <ng-container *ngIf="showConditionalQuestion(question)">
          <p class="block"><span [innerHtml]="question.QuestionTextAlt || question.QuestionText"></span></p>
        </ng-container>
      </ng-container>
    </div>

    <div class="button-wrapper button-wrapper-next-previous text-center float-right">
      <button class="btn btn-prev" (click)="submitBlock(disclosuresForm, 'back')" type="button"><i class="fas fa-angle-left"></i> Prev</button>
      <button class="btn btn-primary btn-next" [disabled]="disableForward" (click)="submitBlock(disclosuresForm, 'fwd')" type="button">Next <i class="fas fa-angle-right"></i></button>
    </div>
  </form>

</main>
<!-- main container -->
</div>